/* eslint-disable no-undef */
import SwalConfig from "@/swalConfig";
import { green } from "../../constants/colors";

const successAlert = (type) => {
  const message =
    localStorage.getItem("language") === "en" || localStorage.getItem("language") === null
      ? type === "created"
        ? "Group created successfully!"
        : type === "updated"
          ? "Group updated successfully"
          : "Group deleted successfully"
      : type === "created"
        ? "تم انشاء المجموعة بنجاح!"
        : type === "updated"
          ? "تم تعديل المجموعة بنجاح"
          : "تم حذف المجموعة بنجاح";
  SwalConfig({
    position: "center",
    icon: "success",
    title: `<span style="color: ${green}; font-size:1.2rem">${message}</span>`,
    showConfirmButton: false,
    timer: 1500,
  });
};

const failAlert = (type) => {
  const message =
    localStorage.getItem("language") === "en" || localStorage.getItem("language") === null
      ? type === "created"
        ? "The Group not created!"
        : type === "updated"
          ? "The Group not edited"
          : "The Group not deleted!"
      : type === "created"
        ? "لم يتم انشاء المجموعة!"
        : type === "updated"
          ? "لم يتم تعديل المجموعة!"
          : "لم يتم حذف المجموعة";
  const html =
    localStorage.getItem("language") === "en"
      ? "<p>Some errors were found <br> Please contact support team!</p>"
      : "<p>تم العثور على بعض المشاكل <br> تواصل مع فريق الدعم من فضلك!</p>";

  SwalConfig({
    position: "center",
    icon: "error",
    title: `<strong style="color: ${green}; font-size:1.2rem"> ${message}</strong>`,
    html,
    confirmButtonColor: green,
    showConfirmButton: true,
  });
};
export { successAlert, failAlert };
